$(document).on('as4-After-Set-Results-Contents', () => {
    $('body').css('overflow', '');
    $('body').css('padding-right', '');
});